export default __webpack_public_path__ + "static/media/persyaratan.826ef631.png";